import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UrlService } from '../../services/url.service';

@Component({
    selector: 'report-generator-filter',
    templateUrl: './report-generator-filter.component.html',
    styleUrls: ['./report-generator-filter.component.scss']
})
export class ReportGeneratorFilterComponent implements OnInit {
    showDropdown = false;
    @ViewChild('presetCheckbox') preset: ElementRef;
    @ViewChild('customCheckbox') custom: ElementRef;

    constructor(private urlService: UrlService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {

            const status = this.urlService.queryParams['isPredefined'];
            if (status) {
                this.preset.nativeElement.checked = status === '1';
                this.custom.nativeElement.checked = status === '0';
            }
        });

    }

    changeFilter() {
        const presetValue = this.preset.nativeElement.checked;
        const customValue = this.custom.nativeElement.checked;

        if ((presetValue && customValue) || (!presetValue && !customValue)) {
            this.urlService.queryParams['isPredefined'] = null;
        } else if (presetValue) {
            this.urlService.queryParams['isPredefined'] = '1';
        } else if (customValue) {
            this.urlService.queryParams['isPredefined'] = '0';
        }

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('report-generator-filter')) this.showDropdown = false;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/report-generator-filter/report-generator-filter.component.ts